import React from 'react';

// 데이터가 없을 경우 빈 데이터를 제공
const emptyData = {
  PM2: '',
  PM3: '',
  합계: '',
};

// 각 카테고리에 대해 필요한 데이터를 자동으로 채워주는 함수
const getDataByCategory = (category, data) => {
  const foundData = data.find(item => item.category === category);
  return foundData
    ? {
        PM2: foundData.PM2 || '',
        PM3: foundData.PM3 || '',
        합계: foundData.합계 || '',
      }
    : emptyData;
};

const SecondContainer = ({ data = [] }) => {
  // 카테고리 리스트
  const categories = ['목표', '실적', '달성율'];

  // 각 카테고리별 데이터를 가져옴
  const totalAvailability = categories.reduce((acc, cat) => {
    acc[cat] = getDataByCategory(cat, data);
    return acc;
  }, {});

  const actualAvailability = categories.reduce((acc, cat) => {
    acc[cat] = getDataByCategory(cat, data);
    return acc;
  }, {});

  return (
    <div className='mb-8 border border-black text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'>
      <div className='flex w-full'>
        {/* 구분과 생산량(Ton) */}
        <div className='w-[12%] border border-black'>
          <div className='bg-blue-200 h-[40px] sm:h-[60px] md:h-[80px] flex justify-center items-center text-center border-b-2 border-black'>
            구분
          </div>
          <div className='bg-blue-200 h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center'>
            가동율 <br />
            (%)
          </div>
        </div>

        {/* 호기 및 데이터 셀들 */}
        <div className='w-[12%] border border-black'>
          <div className='h-[40px] sm:h-[60px] md:h-[80px] border-b-2 border-black page_center bg-blue-200'>호기</div>
          <div className='h-[20px] sm:h-[30px] md:h-[40px] border-b border-gray-400 page_center'>PM2</div>
          <div className='h-[20px] sm:h-[30px] md:h-[40px] border-b border-gray-400 page_center'>PM3</div>
          <div className='h-[20px] sm:h-[30px] md:h-[40px] page_center'>합계</div>
        </div>

        {/* 총가동율 */}
        <div className='w-[36%] border border-black'>
          <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] border-b-2 border-black page_center'>
            총가동율
          </div>
          <div className='flex'>
            {categories.map((category, idx) => (
              <div
                key={idx}
                className={`flex flex-col w-[33.34%] ${idx === categories.length - 1 ? '' : 'b2-r border-black'}`}
              >
                <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 page_center border-b-2 border-black'>
                  {category}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] page_center border-b border-gray-400'>
                  {totalAvailability[category]?.PM2 || ''}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] page_center border-b border-gray-400'>
                  {totalAvailability[category]?.PM3 || ''}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] page_center'>
                  {totalAvailability[category]?.합계 || ''}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 실가동율 */}
        <div className='w-[36%] border border-black'>
          <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] border-b-2 border-black page_center'>
            실가동율
          </div>
          <div className='flex'>
            {categories.map((category, idx) => (
              <div
                key={idx}
                className={`flex flex-col w-[33.34%] ${idx === categories.length - 1 ? '' : 'b2-r border-black'}`}
              >
                <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex items-center justify-center border-b-2 border-black'>
                  {category}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex items-center justify-center border-b border-gray-400'>
                  {actualAvailability[category]?.PM2 || ''}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex items-center justify-center border-b border-gray-400'>
                  {actualAvailability[category]?.PM3 || ''}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex items-center justify-center'>
                  {actualAvailability[category]?.합계 || ''}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 비고 */}
        <div className='w-[12%] border border-black'>
          <div className='bg-blue-200 h-[40px] sm:h-[60px] md:h-[80px] flex items-center justify-center text-center border-b-2 border-black'>
            비고
          </div>
          <div className='h-[20px] sm:h-[30px] md:h-[40px] flex items-center justify-center border-b b-g text-center overflow-hidden'></div>
          <div className='h-[20px] sm:h-[30px] md:h-[40px] flex items-center justify-center text-center b-g'></div>
          <div className='h-[20px] sm:h-[30px] md:h-[40px] flex items-center justify-center text-center'></div>
        </div>
      </div>
    </div>
  );
};

export default SecondContainer;
